import { styledComponent, TextField } from '@hermes/web-components'

export const TextInput = styledComponent(TextField)(({ theme }) => ({
  '.MuiInputBase-root': {
    '.MuiButtonBase-root': {
      zIndex: 999,
      fill: theme.palette.divider,
      '&:hover': {
        fill: theme.palette.primary.main
      }
    },
    svg: {
      zIndex: 998
    },
    '.input-error-icon': {
      fill: theme.palette.error.main
    },
    '.input-check-icon': {
      fill: theme.palette.success.main
    },
    // Hide the clear button for different browsers
    'input[type="search"]::-ms-clear, input[type="search"]::-ms-reveal': {
      display: 'none',
      width: 0,
      height: 0
    },
    'input[type="search"]::-webkit-search-decoration, input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-results-button, input[type="search"]::-webkit-search-results-decoration':
      {
        display: 'none'
      }
  }
}))
